import React, { useState } from 'react';
import styles from './Questions.module.css';

const FAQ = () => {
  const [openIndexes, setOpenIndexes] = useState([]);

  const faqData = [
 
    {
      question: "כמה זה עולה? אני מפחד/ת לחרוג מהתקציב",
      answer: "זו השאלה הכי נפוצה, ובצדק. האמת? מעצבת טובה חוסכת לך לפחות פי 2 מההשקעה. יש לי ספקים משלי עם מחירים הרבה יותר נמוכים, וכמובן שבעת הצורך גם עובדת נהדר עם תקציבים מוגבלים. תכנון נכון מראש מונע את רוב הבלתמים היקרים. אני דווקא נהנית מהאתגר של להוציא תוצאה מדהימה מתקציב מצומצם."
    },
 
    {
      question: "כמה זמן לוקח תהליך כזה?",
      answer: "תלוי במסלול שתבחרו. ליווי מלא לבניית בית פרטי מאפס יכול לקחת עד 3 שנים. שיפוץ מקיף נע בין 4 חודשים לשנה. סטיילינג מלא (כולל תכנון נגרות והחלפת מטבח, ללא שבירת קירות) לוקח כ-3 חודשים. זה תהליך ארוך, ולכן אנרגיות חיוביות והתאמה אישית בינינו זה מאסט מבחינתי."
    },
    {
      question: "איך מתחילים? מה התהליך?",
      answer: "קודם כל, אני שולחת שאלון אפיון מפורט - איך מתנהל הבית שלכם, מה חשוב לכם, מה החלום, איפה אתם מבלים הכי הרבה, האם צריך משרד ביתי. אחר כך עובדים על סקיצות ללא הגבלה עד שזה קולע בול למה שדמיינתם. משם ממשיכים לתכניות ביצוע מפורטות, ובהמשך בחירות מלאות - ריצופים, כלים סניטריים, נגרויות, מטבח, תאורה, ריהוט והכל."
    },
    {
      question: "מה קורה אם אני עושה תהליך כזה לבד?",
      answer: "בואי נהיה כנים - כשמקבלים דירת קבלן, התכנון הראשוני שם לקוי מאוד. הוא סיסטמטי, לא מאופיין לצרכים שלך, ויוצר המון טעויות. בלי תכנון נכון תגלי שהמרחב לא מנוצל כמו שצריך, יצוצו בלתמים יקרים תוך כדי ביצוע, ובסוף תשלמי יותר ותקבלי פחות. חוסר סדר יוצר חוסר שקט - וזה בדיוק מה שאני פה למנוע."
    },
    {
      question: "איך את עוזרת לי לעמוד בתקציב?",
      answer: "מתחילים עם תכניות מדויקות. תכנון נכון מראש = פחות בלתמים ופחות שינויים תוך כדי (שעולים הון). אני לוקחת הכל בחשבון מההתחלה, בוחרת רהיטים וחומרים שמתאימים לתקציב, ומכירה את השוק מספיק טוב כדי למצוא פתרונות יצירתיים. גם ההבנה שלי בהתנהלות מול קבלנים חוסכת לכם כסף ועצבים."
    },
    {
      question: "את עובדת רק עם תקציבים גבוהים?",
      answer: "ממש לא, ואפילו להיפך. אני מוצאת שתקציבים מוגבלים דווקא מאתגרים אותי יותר, ואני נהנית מהם יותר מפרויקטים שאין להם תקרה. יש דרכים להפיק מכל חלל את המקסימום בכל תקציב - צריך רק לדעת איפה לחסוך ואיפה להשקיע."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndexes(prev => 
      prev.includes(index) 
        ? prev.filter(i => i !== index)
        : [...prev, index]
    );
  };

  const isOpen = (index) => openIndexes.includes(index);

  return (
    <section className={styles.faqSection}>
      <div className={styles.faqContainer}>
        {/* Right Side - Header */}
        <div className={styles.faqHeader}>
          <h2 className={styles.faqTitle}>שאלות נפוצות</h2>
          
          <p className={styles.faqDescription}>
            אני יודעת שההחלטה להיכנס לתהליך עיצוב היא משמעותית. 
            הנה התשובות לשאלות שהכי מעסיקות את הלקוחות שלי.
          </p>
          
          <div className={styles.faqCtaWrapper}>
            <a
              href={`https://wa.me/972543324747?text=${encodeURIComponent('היי שירלי הגעתי מהדף שלך אשמח שנדבר')}`}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.faqCtaPrimary}
            >
              <span>בואו נדבר</span>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M19 12H5M12 19l-7-7 7-7" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
          </div>
        </div>

        {/* Left Side - FAQ Items */}
        <div className={styles.faqList}>
          {faqData.map((item, index) => (
            <div key={index} className={styles.faqItem}>
              <button
                onClick={() => toggleFAQ(index)}
                className={styles.faqButton}
                aria-expanded={isOpen(index)}
              >
                <span className={styles.faqQuestion}>{item.question}</span>
                <span className={`${styles.faqIcon} ${isOpen(index) ? styles.faqIconOpen : ''}`}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 5v14M5 12h14" strokeLinecap="round"/>
                  </svg>
                </span>
              </button>
              <div 
                className={styles.faqAnswer}
                style={{
                  maxHeight: isOpen(index) ? '400px' : '0',
                  opacity: isOpen(index) ? 1 : 0
                }}
              >
                {isOpen(index) && (
                  <div className={styles.faqAnswerInner}>
                    <p className={styles.faqAnswerText}>{item.answer}</p>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;